import React, { useState, useEffect } from 'react';
import { Modal, DatePicker, Spin, message } from 'antd';
import './ExportCSVDialog.css'
import { getDetailedSensorDataWithFromTo, getDetailedSensorDataMqttWithFromTo } from '../../../../services/common/sensor_apis';
import { ExportToCsv } from 'export-to-csv';
import { useSelector } from 'react-redux';
import moment from "moment";
import lang from '../../../../services/lang';
function ExportCSVDialog(props) {
    const {langIndex} = useSelector(x=>x.app);
    const { customerId, timezone, isShowingExportModal, setShowingExportModal, sensorInfo} = props;
    const [isReading, setIsReading] = useState(false);
    const [fromDate, setFromDate] = useState();
    const [toDate, setToDate] = useState();


    const sensor_id = sensorInfo.sensor_id;
    
    const onClickExport = () => {
        if (isReading) {
            message.warn("Your request is on processing...");
            return;
        }
        if (fromDate === undefined || toDate === undefined || fromDate.diff(toDate) > 0) {
            message.warn("Please specify the valid date");
            return;
        }

        setIsReading(true);

        if (Number(sensorInfo.communication_type) === 1) {
          getDetailedSensorDataMqttWithFromTo(customerId, sensor_id, fromDate.format('YYYY-MM-DD 00:00:00'), toDate.format('YYYY-MM-DD 23:59:59'), res => {
            setIsReading(false);
            if (res == null) {
                message.error(lang(langIndex, 'msg_something_wrong'));
                return;
            }

            let csvData = [];
            res.forEach(x => {
              csvData.push([
                sensorInfo.sensor_name,
                x.sensor_id,
                moment(x.created_at * 1000).utcOffset(timezone).format("YYYY-MM-DD HH:mm"),
                x.value1,
                x.value2,
                x.value3,
              ]);
            });

            const options = {
                filename: `SensorData(${fromDate.format('MM/DD/YYYY')}-${toDate.format('MM/DD/YYYY')})`,
                fieldSeparator: ',',
                quoteStrings: '"',
                decimalSeparator: '.',
                showLabels: true,
                showTitle: true,
                title: 'csv data',
                useTextFile: false,
                useBom: true,
                useKeysAsHeaders: false,
                // headers: ['Column 1', 'Column 2', etc...] <-- Won't work with useKeysAsHeaders present!
                headers: ['Sensor Name', 'Sensor ID', 'Date/time', 'Value1', 'Value2', 'Value3'],
            };
            const csvExporter = new ExportToCsv(options);
            csvExporter.generateCsv(csvData);

            message.success("Success");
            setShowingExportModal(false);
          });
        } else {
          getDetailedSensorDataWithFromTo(sensor_id, fromDate.format('YYYY-MM-DD 00:00:00'), toDate.format('YYYY-MM-DD 23:59:59'), res => {
            setIsReading(false);
            if (res == null) {
                message.error(lang(langIndex, 'msg_something_wrong'));
                return;
            }

            let csvData = [];
            res.forEach(x => {
              csvData.push([
                sensorInfo.sensor_name,
                x.sensor_id,
                moment(x.created_at * 1000).utcOffset(timezone).format("YYYY-MM-DD HH:mm"),
                x.value1,
                x.value2,
                x.value3,
              ]);
            });

            const options = {
                filename: `SensorData(${fromDate.format('MM/DD/YYYY')}-${toDate.format('MM/DD/YYYY')})`,
                fieldSeparator: ',',
                quoteStrings: '"',
                decimalSeparator: '.',
                showLabels: true,
                showTitle: true,
                title: 'csv data',
                useTextFile: false,
                useBom: true,
                useKeysAsHeaders: false,
                // headers: ['Column 1', 'Column 2', etc...] <-- Won't work with useKeysAsHeaders present!
                headers: ['Sensor Name', 'Sensor ID', 'Date/time', 'Value1', 'Value2', 'Value3'],
            };
            const csvExporter = new ExportToCsv(options);
            csvExporter.generateCsv(csvData);

            message.success("Success");
            setShowingExportModal(false);
          });
        }
        
    }
    return (
      <div>
        <Modal
          title={"Export CSV Modal"}
          visible={isShowingExportModal}
          onOk={onClickExport}
          onCancel={() => setShowingExportModal(false)}
          destroyOnClose={true}
          className="export-sensor-csv-modal"
        >
          <div>
            <div className="sensor-detail-one-sensor-name">
              <div className="sensor-detail-one-sensor-info-title">
                From Date:
              </div>
              <div className="sensor-detail-one-sensor-info-value">
                <DatePicker
                  className="detail-page-one-date"
                  format="MM/DD/YYYY"
                  onChange={(value) => setFromDate(value)}
                />
              </div>
            </div>
            <div className="sensor-detail-one-sensor-name">
              <div className="sensor-detail-one-sensor-info-title">
                To Date:
              </div>
              <div className="sensor-detail-one-sensor-info-value">
                <DatePicker
                  className="detail-page-one-date"
                  format="MM/DD/YYYY"
                  onChange={(value) => setToDate(value)}
                />
              </div>
            </div>
            {isReading && (
              <Spin spinning={isReading} size="large" style={{ marginTop: 10 }}>
                <div
                  style={{
                    width: "100%",
                    textAlign: "center",
                    fontSize: 20,
                    color: "#eeeeee",
                    background: "transparent",
                  }}
                >
                  Reading Sensor data...
                </div>
              </Spin>
            )}
          </div>
        </Modal>
      </div>
    );
}

export default ExportCSVDialog;